import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20interior%20with%20warm%20orange%20and%20golden%20ambient%20lights%2C%20luxurious%20velvet%20seats%2C%20large%20blank%20screen%20with%20warm%20glow%2C%20soft%20atmospheric%20lighting%2C%20elegant%20cinema%20architecture%2C%20cozy%20and%20inviting%20atmosphere&width=1800&height=900&seq=mango-hero-bg&orientation=landscape"
        alt="芒果视频 - 优质视频平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-4xl mx-auto">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white font-heading mb-5 leading-tight">
          蜜桃视频、糖豆视频之外的
          <br />
          <span className="text-primary-400">优质视频平台推荐</span>
        </h1>
        <p className="text-base md:text-lg text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
          芒果视频 —— 资源丰富、播放流畅、免费高清在线观看。
          对比蘑菇视频、蓝莓视频，芒果视频App更好用，值得选择。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/dianying"
            className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-lg text-base font-medium hover:bg-primary-600 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            立即观影
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 bg-white/15 text-white rounded-lg text-base font-medium hover:bg-white/25 transition-all backdrop-blur-sm whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
        <div className="mt-10 flex items-center justify-center gap-6 text-white/60 text-sm">
          <span className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-fill text-accent-400"></i>
            免费高清
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-fill text-accent-400"></i>
            资源丰富
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-fill text-accent-400"></i>
            流畅不卡顿
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-fill text-accent-400"></i>
            多端支持
          </span>
        </div>
      </div>
    </section>
  );
}